//#region Private methods
const naturalSorter = (a, b) => {
  if (a === b) return 0;
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
};

//#endregion Private methods

// #region Public methods

// Sorts the treatments alphabetically by name. Complimentary consultation is always first
export const sortTreatments = (a, b) =>
  a.displayName.toLowerCase() === "complimentary consultation"
    ? -3
    : b.displayName.toLowerCase() === "complimentary consultation"
    ? 3
    : a.displayName.toLowerCase() === "weight loss program | consultation"
    ? -2
    : b.displayName.toLowerCase() === "weight loss program | consultation"
    ? 2
    : a.displayName.toLowerCase() === "nutritionist visit | virtual"
    ? -1
    : b.displayName.toLowerCase() === "nutritionist visit | virtual"
    ? 1
    : naturalSorter(a.displayName, b.displayName);

// #endregion Public methods
